import React from 'react';
import styled from 'styled-components';

import { Markdown, Subtitle } from '../elements';

const Section = styled.section`
  background: linear-gradient(90deg, #f0f0f0 50%, #636567 50%);
  @media (max-width: 768px) {
    background: #ffffff;
  }

  span {
    color: ${(props) => props.theme.mainBrandColor};
  }
  h2,
  h3 {
    font-weight: 700;
  }
  .card {
    border: 3px solid ${(props) => props.theme.mainBrandColor};
    border-radius: 0;
    height: 100%;
  }
`;

const Testimonial = ({ heading, testimonials = [] }) => {
  return (
    <Section className="section is-medium">
      <div className="container">
        <Markdown className="pb-4 has-text-grey-dark has-text-left">
          {heading}
        </Markdown>

        <div className="columns is-multiline">
          {testimonials &&
            testimonials.map((item) => {
              if (!item) return null;
              return (
                <div className="column is-4" key={item._id}>
                  <div className="card py-4">
                    <div className="card-content">
                      <div className="media">
                        <div className="media-left">
                          <figure className="image is-48x48">
                            <img src="/images/quotes.svg" alt="quotes" />
                          </figure>
                        </div>
                        <div className="media-content pt-5">
                          <Subtitle dark className="subtitle is-6 pt-4">
                            {item.description}
                          </Subtitle>
                          {item.clientName && (
                            <h2 className="subtitle is-6 pt-4 has-text-grey-dark">
                              {item.clientName}
                            </h2>
                          )}
                          {item.type && (
                            <h3 className="title is-6 pt-2 has-text-grey-dark">
                              {item.type}
                            </h3>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Section>
  );
};

export default Testimonial;
